// Make sure these are in sync with the presets in MarkitBackEnd's instagramPresetUtils.ts

/** Require Follow Preset */
export const FOLLOW_GATE_PROMPT_TEXT =
  "Make sure you're following before we can send it over. Then hit the button to continue";

/** Phone Prompt Preset */
export const PHONE_PROMPT_STATIC_PREFIX =
  "Hi! What's the best number to reach you at? I'll send it to you in a text.";
